































































































import TeamMembers from "@/components/teams/team-members.vue";
import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import { Team } from "@/swagger/models";
import { Committable, WrapService } from "@/plugins/committable";
import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import Card from "@/components/layout/card.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import { subject } from "@casl/ability";
import { teamService } from "@/services/team";
import TabsSettings from "@/components/tabs/settings.vue";
import alert from "@/components/misc/alert.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "team",
    components: { TeamMembers, TabsSettings, PageHeader, Card, CommitResetBar, Page, alert },
})
export default class TeamView extends Vue {
    committable: Committable<Team>;

    // nextId: number = null;
    // previousId: number = null;

    async created() {
        try {
            this.committable = new Committable<Team>({
                onCommit: WrapService(teamService, {
                    ignoredFields: ["deletedAt"],
                    routeIdParam: "teamId",
                    router: this.$router,
                }),
            });

            if (this.$route.params.teamId === "new") {
                this.committable.set(
                    teamService.build({
                        customerId: parseInt(this.$route.params.customerId),
                    }),
                );
            } else {
                const res = await teamService.getNew(parseInt(this.$route.params.teamId));
                this.committable.set(res.data);
                // this.previousId = res.previousId;
                // this.nextId = res.nextId;
            }
        } catch (e) {
            console.warn(e);
            await this.$router.back();
        }
    }

    get canEdit() {
        if (this.committable.loading.value) return false;
        // @ts-ignore
        if (this.$route.params.teamId === "new" && this.$can("create", "Team")) return true;
        // @ts-ignore
        else if (this.$can("update", subject("Team", this.committable?.original?.value))) return true;
        return false;
    }

    async deleteTeam() {
        if (this.$route.params.teamId === "new") return;
        if (!confirm("Are you sure you want to delete this team?")) return;
        await teamService.delete(parseInt(this.$route.params.teamId));
        await this.$router.replace({ name: "teams" });
    }
}
